<template>
    <accounts-component-template
        component-name="Programs"
        component-key="programs"
        color="#A8D37D">
        class="programs-container"
        <template v-slot:icon>
            <cloud-refresh-icon :size="16"/>
        </template>
        <template v-slot:content>
            <div class="flex">
                <div class="account-programs-component" :style="{width: '33%'}">
                    <div class="account-details-formfield">
                        <label class="account-details-checkboxfield">
                            <input type="checkbox" :checked="settings.programsEnabled"
                                   @input="setProgramsEnabled($event.target.checked)"/>
                            <span>Enable Programs for this account</span>
                        </label>

                        <div class="account-details-fieldset">
                            <div class="account-details-radiofield">
                                <label>
                                    <input :disabled="!settings.programsEnabled" type="radio" name="toggle_programs"
                                           value="true" v-model="programsVisible"/>
                                    <span>Show Programs for users of this account </span>
                                </label>
                                <label>
                                    <input :disabled="!settings.programsEnabled" type="radio" name="toggle_programs"
                                           value="false" v-model="programsVisible"/>
                                    <span>Hide Programs for users of this account </span>
                                </label>
                            </div>
                            <div class="account-details-checkboxfield" @click="schedulerEnabled = !schedulerEnabled">
                                <input style="float:left;" :disabled="!settings.programsEnabled" type="checkbox"
                                       v-model="schedulerEnabled"/>
                                <span>Enable Programs Scheduler for this account (required to set up automated orders)</span>
                            </div>
                            <label>
                                <input class="account-details-program-mandatory" type="checkbox"
                                       :checked="isProgramMandatory" :disabled="!settings.programsEnabled"
                                       @input="setProgramPreference($event.target.checked)"/>
                                <span>Make program mandatory for this account</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="assign-templates-section" >
                    <h2>Assign Templates</h2>
                    <p class="note">Note: templates assigned through programs take precedent over templates associated
                        with order types.</p>
                    <div class="template-assignment-container">
                        <div class="template-assignment" v-for="program in programData" :key="program.id">
                            <div class="program">
                                <div style="min-width: 300px">
                                    <input type="checkbox"
                                           :id="`program-name-${program.id}`"
                                           v-model="program.plunet_template_enabled" @change="(e) => updateProgramPlunetSetting(program.id, 'plunet_template_enabled', e.target.checked)">

                                    <label :for="`program-name-${program.id}`">{{ program.name }}</label>
                                </div>
                                <div>
                                    <label class="input-select">Order Template</label>
                                    <v-select
                                        :options="orderTemplates"
                                        v-model="program.plunet_order_template_id"
                                        label="description"
                                        class="input-select"
                                        :reduce="x => x.plunetid"
                                        @input="(x) => {
                                            updateProgramPlunetSetting(program.id, 'plunet_order_template_id', x)
                                        }"
                                    >
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                                        </template>
                                    </v-select>
                                    <label class="input-select">Quote Template</label>
                                    <v-select
                                        :options="quoteTemplates"
                                        v-model="program.plunet_quote_template_id"
                                        label="description"
                                        class="input-select"
                                        :reduce="x => x.plunetid"
                                        @input="(x) => {
                                            updateProgramPlunetSetting(program.id, 'plunet_quote_template_id', x)
                                        }"
                                    >
                                        <template #open-indicator="{ attributes }">
                                            <span v-bind="attributes"><chevron-down-icon :size="24"/></span>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </accounts-component-template>
</template>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {mapActions, mapGetters} from 'vuex';
import {
    ChevronDownIcon,
    CloudRefreshIcon,
} from "../../components/icons";
import axios from "axios";

export default {

    props: {
        programs: {
            required: true
        },
        isProgramMandatory: {
            type: Boolean,
            required: true
        },
        accountId: {
            type: [Number, String],
            required: true,
        },
        account: {
            required: true
        },
        quoteTemplates: {
            required: true
        },
        orderTemplates: {
            required: true
        },
    },


    components: {
        AccountsComponentTemplate,
        CloudRefreshIcon,
        ChevronDownIcon,
    },
    beforeMount() {

        this.programData = this.programs

        //get Account data
        this.getAccount(this.account.id).then(result => {
            console.log('the account data', result);
        })

        this.loadProgramPreferencesData(this.account.id).then(result => {
            console.log('programs prefs data', result);
        });
    },
    data() {
        return {
            programData: {},
        }
    },
    computed: {
        ...mapGetters('AdminAccountDetailsStore', [
            'programSettings',
        ]),

        settings() {
            return this.programSettings;
        },

        programsVisible: {

            get() {
                return this.programSettings.programsVisibleToClients;
            },

            set(value) {
                console.log('visible value', value);
                this.setProgramsVisibility(value);
            }
        },

        schedulerEnabled: {

            get() {
                return this.programSettings.programsSchedulerEnabled;
            },

            set(value) {
                this.setProgramScheduler(value);
            }
        }
    },

    methods: {

        ...mapActions('AdminAccountDetailsStore', [
            'enableAccountPrograms',
            'updateProgramsVisibility',
            'updateProgramSchedulerStatus',
            'setAccountPreference',
            'getAccount',
            'loadProgramPreferencesData',
        ]),
        updateProgramPlunetSetting(id, field, value){

            const updatedArray = [...this.programData];

            // Find the index of the object with the provided id
            const index = updatedArray.findIndex(item => item.id === id);

            // If the object is found, update the key with the new value
            if (index !== -1) {
                updatedArray[index] = {
                    ...updatedArray[index],
                    [field]: value
                };
            }

            this.programData = updatedArray;
            this.updateProgramSetting(id, field, value)
        },
        async updateProgramSetting(program_id, field, value = 0) {
            console.log(program_id, field, value)
            axios.post(`/admin/account/set-program-plunet-template`, {
                program_id, field, 'value': value
            }).then((res) => console.log(res));
        },

        setProgramsEnabled(isEnabled) {
            const payload = {
                isEnabled,
                accountId: this.accountId
            };

            this.enableAccountPrograms(payload).then(result => {
                if (!result) {
                    //show some error
                }
            });
        },

        setProgramsVisibility(isVisible) {
            const payload = {
                status: isVisible == 'true',
                accountId: this.accountId
            };

            this.updateProgramsVisibility(payload).then(result => {
                if (!result) {
                    //show some error
                }
            });
        },

        setProgramScheduler(isEnabled) {
            const payload = {
                status: isEnabled,
                account_id: this.accountId
            };

            console.log('scheduler paylaod', payload)

            this.updateProgramSchedulerStatus(payload).then(result => {
                if (!result) {
                    //show some error
                }
            });
        },

        /**
         * Set Account's program preference
         * @param {boolean} isProgramMandatory
         */
        setProgramPreference(isProgramMandatory) {
            console.log(this.settings);
            console.log(this);

            const payload = {
                isProgramMandatory,
                accountId: this.accountId
            };
            this.setAccountPreference(payload);
        },
    }
}
</script>

<style scoped>
.programs-container {
    display: flex;
    justify-content: space-between;
    padding: 20px;
    background: #f9f9f9;
}

.settings-section, .assign-templates-section {
    background: white;
    padding-left: 20px;
    border-left: 1px solid lightgray;
    width: 100%;

}

h2 {
    font-size: 20px;
    color: #333;
    margin-bottom: 10px;
}

.setting-item, .program {
    margin-bottom: 15px;
    display: flex;
    align-items: center;
}

.setting-item input[type="checkbox"], .setting-item input[type="radio"] {
    margin-right: 10px;
}

.template-assignment-container {
    max-height: 500px;
    overflow-y: scroll;
}

.template-assignment {
    border-bottom: 1px lightgray solid;
}


.template-assignment input[type="text"] {
    margin-left: 10px;
    padding: 8px;
    border: 1px solid #ddd;
    border-radius: 4px;
}

.note {
    font-style: italic;
    margin-bottom: 15px;
}

.input-select {
    min-width: 250px;
    margin: 0 10px;
    max-width: 350px;
}

</style>
